import gql from 'graphql-tag';

export const LabelsCountQuery = gql`
	query LabelsCountQuery($contentId: ID!, $status: [String]) {
		singleContent(id: $contentId, status: $status) {
			id
			labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
				count
			}
		}
	}
`;
